import {Button, Alert, Box, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {userServices} from "../../service/userService";
import Spinner from "../spinner/Spinner";
import {AuthCard, AuthLayout} from "./AuthDesign";
import {CheckCircleOutline, MailOutline} from "@mui/icons-material";

function ConfirmInvitation() {
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const action = params.get('action');

    useEffect(() => {
        setLoading(true);
        userServices.updateInvitation(token, action).then((response) => {
            console.log(response);
        }).catch((error) => {
            setErrorMsg(error?.response?.data?.error);
        }).finally(() => {
            setLoading(false);
        });

    }, [token, action]);

    const declined = action === 'decline';
    return <AuthLayout session><AuthCard maxWidth={480} title={loading ? 'Confirming your invitation' : errorMsg ? 'Unable to confirm invitation' : declined ? 'Invitation declined' : 'Invitation accepted'}
        description={loading ? 'Please wait while we update your invitation.' : errorMsg ? 'There was a problem updating your invitation.' : declined ? 'You have declined this workspace invitation.' : 'Your invitation has been accepted and access granted.'}>
        {loading ? <Box role="status" aria-label="Updating invitation" sx={{display: 'flex', justifyContent: 'center', py: 3}}><Spinner size={28}/></Box> : <>
            {errorMsg ? <Alert severity="error" variant="filled">{errorMsg}</Alert> : <Box sx={{textAlign: 'center', py: 2}}>
                {declined ? <MailOutline sx={{fontSize: 48, color: 'text.secondary'}}/> : <CheckCircleOutline sx={{fontSize: 48, color: 'primary.main'}}/>}
            </Box>}
            <Button fullWidth variant="contained" href={!declined && !errorMsg ? '/login' : 'https://skro.eu'}>
                {!declined && !errorMsg ? 'Continue to sign in' : 'Go to homepage'}
            </Button>
            {!errorMsg && !declined && <Typography sx={{mt: 2, color: 'text.secondary', fontSize: 12, textAlign: 'center'}}>Sign in to access your team’s workspace.</Typography>}
        </>}
    </AuthCard></AuthLayout>;
}

export default ConfirmInvitation;
